import { GraphQLClient, gql } from 'graphql-request';

const config = {
    graphQlUrl: location.hostname !== 'localhost' ? `https://editello.com/graphql` : 'http://localhost:8082/graphql',
}

export default {
    getOneByCode,
    updateDraft,
};

async function getOneByCode(code) {

    const endpoint = config.graphQlUrl

    const graphQLClient = new GraphQLClient(endpoint, {
      credentials: 'include',
      mode: 'cors',
      headers: {
        // authorization: 'Bearer MY_TOKEN',
      },
    })

    const query = gql`
      {
        draft(code: "${code}") {
            id,
            name,
            code,
            preview,
            attributes {
                active
            },
            scenes: items {
                id,
                name,
                attributes {
                    guestList,
                    exportAll,
                    optional,
                    tabs
                },
                versions {
                    id,
                    name,
                    content,
                    width,
                    height,
                    border,
                    borderColor,
                    margin,
                    cuttingLine,
                    attributes {
                      personalizedField,
                      blockFonts
                    },
                }
            }
        }
      }
    `

    const data = await graphQLClient.request(query)

    return data.draft
}

async function updateDraft(items) {

    const endpoint = config.graphQlUrl

    const graphQLClient = new GraphQLClient(endpoint, {
      credentials: 'include',
      mode: 'cors',
      headers: {
        // authorization: 'Bearer MY_TOKEN',
      },
    })

    const updateData = []

    items.forEach((item) => {
        console.log('item name', item.name)
        console.log('item versions', item.versions)
        item.versions.forEach((version) => {
            updateData.push({ 
                id: version.id,
                content: version.content
            })
        })
    });

    const query = gql`
      mutation updateDraftVersions($versions: String!) {
        updateDraftVersions(versions: $versions) {
            success
        }
      }
    `

    const data = await graphQLClient.request(query, {
        versions: JSON.stringify(updateData)
    })

    if (!data.updateDraftVersions.success) {
        throw new Error('Cannot update')
    }

    console.log('data', data)

    // return data.draft
}